module.exports = __webpack_public_path__ + "img/LMS Aset Illustrasi No Course.5e280bc3.png";